<svg
  width="18"
  height="18"
  viewBox="0 0 18 18"
>
  <use [attr.xlink:href]="icon()"></use>
</svg>

@if (isShown()) {
  <div (libOutsideClick)="dismiss()">
    <ng-content />
  </div>
}
